import { Route } from "react-router-dom";
import { ProtectedRoute } from "../hooks/rute/ProtectedRoute";
import { ProtectedRoleResourceManager } from "../hooks/roles/ProtectedRoleResourceManager";
import React from "react";
import { LazySuspense } from "../components/layout/AppHeader/lazySuspense";

const ErrorPage = React.lazy(() => import("../components/error-page"));
const TareaDetalleEstimacionSinAtender = React.lazy(
  () =>
    import(
      "../components/task/accountManager/tareaDetalleEstimacionSinAtender/tarea-detalle-estimacion-sin-atender"
    )
);

export function tareaDetalleEstimacionSinAtender() {
  return (
    <Route
      path="/tarea-detalle-estimacion-sin-atender"
      element={
        <LazySuspense>
          <ProtectedRoute>
            <ProtectedRoleResourceManager>
              <LazySuspense>
                <TareaDetalleEstimacionSinAtender />
              </LazySuspense>
            </ProtectedRoleResourceManager>
          </ProtectedRoute>
        </LazySuspense>
      }
      errorElement={
        <LazySuspense>
          <ErrorPage />
        </LazySuspense>
      }
    />
  );
}
